import React from 'react';
import './ChapterNav.css';

const ChapterNav = ({ 
  chapters, 
  selectedChapter, 
  onChapterSelect, 
  onOverviewClick,
  isOverviewActive,
  children 
}) => {
  return (
    <div className="chapter-nav">
      <h3 className="nav-title">Navigation</h3>
      
      <button 
        className={`nav-item overview-btn ${isOverviewActive ? 'active' : ''}`}
        onClick={onOverviewClick}
      >
        <span className="nav-icon">📖</span>
        <span className="nav-text">Book Overview</span>
      </button>
      
      <div className="chapters-divider">
        <span>Chapters</span>
      </div>
      
      <div className="chapters-list">
        {chapters.map((chapter) => (
          <button
            key={chapter.ChapterNumber}
            className={`nav-item chapter-btn ${
              selectedChapter?.ChapterNumber === chapter.ChapterNumber ? 'active' : ''
            }`}
            onClick={() => onChapterSelect(chapter)}
          >
            <span className="chapter-number">{chapter.ChapterNumber}</span>
            <span className="chapter-title">{chapter.Title}</span>
          </button>
        ))}
      </div>
      
      {chapters.length === 0 && (
        <p className="no-chapters">No chapters available</p>
      )}
      
      {children}
    </div>
  );
};

export default ChapterNav;
